function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Crop");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.3
}, React.createElement("g", {
  id: "2.1-\\u2013-rates-(Select)-Renewals-rates-choosen-OPTION-2",
  transform: "translate(-946.000000, -732.000000)"
}, React.createElement("g", {
  id: "Group-35",
  transform: "translate(944.000000, 729.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  opacity: 0,
  x: 0,
  y: 0,
  width: 28,
  height: 30
}), React.createElement("g", {
  id: "noun_Crop_860202",
  transform: "translate(2.000000, 3.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M22.8059701,17.1044776 L19.4925373,17.1044776 L19.4925373,4.50746269 L6.89552239,4.50746269 L6.89552239,1.19402985 C6.89552239,0.537313433 6.35820896,0 5.70149254,0 C5.04477612,0 4.50746269,0.537313433 4.50746269,1.19402985 L4.50746269,4.50746269 L1.19402985,4.50746269 C0.537313433,4.50746269 0,5.04477612 0,5.70149254 C0,6.35820896 0.537313433,6.89552239 1.19402985,6.89552239 L4.50746269,6.89552239 L4.50746269,19.4925373 L17.1044776,19.4925373 L17.1044776,22.8059701 C17.1044776,23.4626866 17.641791,24 18.2985075,24 C18.9552239,24 19.4925373,23.4626866 19.4925373,22.8059701 L19.4925373,19.4925373 L22.8059701,19.4925373 C23.4626866,19.4925373 24,18.9552239 24,18.2985075 C24,17.641791 23.4626866,17.1044776 22.8059701,17.1044776 Z M17.1044776,6.89552239 L17.1044776,17.1044776 L6.89552239,17.1044776 L6.89552239,6.89552239 L17.1044776,6.89552239 Z",
  id: "Shape"
})))));

const SvgCrop = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCrop, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/crop.6b48b20d.svg";
export { ForwardRef as ReactComponent };